import React from 'react'
import gql from 'graphql-tag'
import {shouldShowDeliveredPhotos, productIsDelivered} from 'lib/productHelpers'
import DeliveredPhotos from 'components/shared/DeliveredPhotos'
import DefaultProductStatus from '../../DefaultProductStatus'

const FacadePhotoProduct = ({match, product, viewer}) => {
  if (shouldShowDeliveredPhotos(product)) {
    const photoOrder = viewer.photoOrderPreference.edges.map(edge => edge.node.name)
    const isDelivered = productIsDelivered(product)
    return (
      <DeliveredPhotos
        estateId={match.params.estateId}
        product={product}
        photoOrder={photoOrder}
        canCreateCorrections={isDelivered && viewer.customer.canCreateCorrections}
        customProfiles={isDelivered && viewer.customer.customProfiles}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

FacadePhotoProduct.fragment = gql`
  fragment FacadePhotoProduct on FacadePhotoProduct {
    booking {
      id
      startsAt
      endsAt
      resourceName
    }
    order {
      expressDelivery
    }
  }
`

export default FacadePhotoProduct
